import { CSSProperties, ReactNode } from "react";
import { Dayjs } from "dayjs";
import { DatePicker } from "antd";
import type { DatePickerProps } from "antd";

export type UIDatePickerProps = Omit<
  DatePickerProps<Dayjs>,
  "size" | "onChange" | "value"
> & {
  label?: ReactNode;
  value?: Dayjs | null;
  onChange?: (date: Dayjs | null) => void;
  slotProps?: {
    textField?: {
      size?: "small" | "medium" | "large";
      sx?: Record<string, unknown>;
    };
  };
  sx?: Record<string, unknown>;
};

const toInputSize = (
  size?: "small" | "medium" | "large"
): "small" | "middle" | "large" => {
  if (size === "small") return "small";
  if (size === "large") return "large";
  return "middle";
};

export const UIDatePicker = ({
  label,
  value,
  onChange,
  slotProps,
  sx,
  style,
  ...props
}: UIDatePickerProps) => {
  const wrapperStyle = (sx ?? {}) as CSSProperties;
  const inputStyle = (slotProps?.textField?.sx ?? {}) as CSSProperties;

  return (
    <div style={{ ...wrapperStyle }}>
      {label ? <label style={{ display: "block", marginBottom: 6 }}>{label}</label> : null}
      <DatePicker
        size={toInputSize(slotProps?.textField?.size)}
        value={value ?? undefined}
        onChange={(date) => onChange?.(Array.isArray(date) ? null : date)}
        style={{ width: "100%", ...inputStyle, ...style }}
        format="YYYY-MM-DD"
        {...props}
      />
    </div>
  );
};
